import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Tab from "./Tab";
import { Container, CustomNav, NavContainer } from "./style";
import { KEY_NUMBERS } from "../../constants/keyboardKeys";
import Text from "../Text";

var Tabber = function Tabber(_ref) {
  var children = _ref.children,
      noAnimation = _ref.noAnimation,
      justifyContent = _ref.justifyContent;

  var _useState = useState(0),
      selectedIndex = _useState[0],
      setSelectedIndex = _useState[1];

  var _useState2 = useState(new Map()),
      widthMap = _useState2[0],
      setWidthMap = _useState2[1];

  var _useState3 = useState([]),
      tabs = _useState3[0],
      setTabs = _useState3[1];

  var handleSelectClick = function handleSelectClick(newIndex) {
    return function (_e) {
      setSelectedIndex(newIndex);
    };
  };

  var handleKeyDown = function handleKeyDown(newIndex) {
    return function (e) {
      var triggerKeys = [KEY_NUMBERS.KEY_ENTER, KEY_NUMBERS.KEY_SPACE];
      if (!triggerKeys.includes(e.which)) return;

      setSelectedIndex(newIndex);
      e.preventDefault();
    };
  };

  useEffect(function () {
    var currentIndex = 0;
    var newTabCollection = React.Children.map(children, function (child, _childIndex) {
      if (!child.props.isTab) return null;
      var widthSize = child.props.title.length * 8 || 90;
      setWidthMap(function (currentMap) {
        return currentMap.set(currentIndex, widthSize);
      });
      var newChild = React.cloneElement(child, {
        index: currentIndex,
        width: widthSize
      });
      currentIndex += 1;

      return newChild;
    });

    setTabs(newTabCollection);
  }, [children]);

  return React.createElement(
    Container,
    null,
    React.createElement(
      NavContainer,
      {
        selectedIndex: selectedIndex,
        widthMap: widthMap,
        noAnimation: noAnimation,
        justifyContent: justifyContent
      },
      tabs.map(function (tab) {
        return React.createElement(
          CustomNav,
          {
            key: "tab-" + tab.props.index,
            onKeyDown: handleKeyDown(tab.props.index),
            onClick: handleSelectClick(tab.props.index),
            isSelected: tab.props.index === selectedIndex,
            width: tab.props.width,
            tabIndex: 0,
            noAnimation: noAnimation
          },
          React.createElement(
            Text,
            { noMargin: true, size: "md", semiBold: true },
            tab.props.title
          )
        );
      })
    ),
    tabs[selectedIndex]
  );
};

Tabber.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  noAnimation: PropTypes.bool,
  justifyContent: PropTypes.string
};

Tabber.defaultProps = {
  noAnimation: false,
  justifyContent: "flex-start"
};

Tabber.Tab = Tab;

export default Tabber;